import { koComponent } from '../../../../ko-utils';
import $api from '../../../../api';
import constructGeneralPerformance from './charts/generalPerformance';

class ChecklistPerformanceView {
    constructor(params) {
        this.isVisible = params.isVisible;
        this.isVisible.subscribe(val => {
            this.reinitIfVisible();
        });

        this.globalDateRange = params.globalDateRange;
        this.globalDateRange.subscribe(() => {
            this.reinitIfVisible();
        });

        this.checklistId = params.checklistId;

        this.generalChartState = ko.observable('loading');
        this.generalChartOptions = ko.observable({});

        this.checklistIdSubscription = this.checklistId.subscribe(() => {
            this.reinit();
        });

        this.reinitIfVisible();
    }

    get globalDateRangeUnwrapped() {
        return ko.unwrap(this.globalDateRange);
    }

    dispose() {
        this.checklistIdSubscription.dispose();
    }

    reinitIfVisible() {
        if (ko.unwrap(this.isVisible)) {
            this.reinit();
        }
    }

    reinit() {
        this.generalChartState('loading');
        this.generalChartOptions({});
        this.loadGeneralChart();
    }

    loadGeneralChart() {
        $api.insights.getChecklistGeneralPerformance(
            {
                projectCode: auth.project.UniqueCode,
                id: ko.unwrap(this.checklistId),
                from: this.globalDateRangeUnwrapped[0].toJSON(),
                to: this.globalDateRangeUnwrapped[1].toJSON()
            },
            {},
            (resp) => {
                var strDates = Object.keys(resp);

                var finished = [];
                var dismissed = [];
                var touched = [];

                for (var key of strDates) {
                    finished.push(resp[key].finishedCount);
                    dismissed.push(resp[key].dismissedCount);
                    touched.push(resp[key].touchedCount);
                }

                if (finished.every(i => i === 0) && dismissed.every(i => i === 0)) {
                    this.generalChartState('empty');
                } else {
                    this.generalChartState('loaded');
                }

                var xAxisCategories = strDates.map(i => new Date(i).toJSON());

                this.generalChartOptions(constructGeneralPerformance(xAxisCategories, finished, dismissed, touched));
            }
        );
    }
}

export default koComponent('checklist-performance-view', ChecklistPerformanceView);